import React from "react";
import { FAQ_ITEMS } from "../marketingData";
import { PlusIcon } from "../shared/icons";

const FAQSection = ({ openFaqIndex, onToggleFaq }) => (
  <section className="faq-section" id="faq">
    <div className="faq-inner">
      <div className="faq-head reveal">
        <span className="section-eyebrow">FAQ</span>
        <h2 className="section-h2">Straight answers.</h2>
        <p className="section-p">The questions serious sellers actually ask before migrating.</p>
      </div>
      <div className="faq-list">
        {FAQ_ITEMS.map((item, index) => (
          <div
            className={`faq-item${openFaqIndex === index ? " open" : ""}`}
            key={item.q}
          >
            <div className="faq-q" onClick={() => onToggleFaq(index)} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && onToggleFaq(index)}>
              <span className="faq-q-text">{item.q}</span>
              <div className="faq-icon">
                <PlusIcon />
              </div>
            </div>
            <div className="faq-a">
              <div className="faq-a-inner">{item.a}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FAQSection;
